export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00468.3b45363d.png";